/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Fault_Tap_RetryInputs */

const en_mobile_player_fault_tap_retry = /** @type {(inputs: Mobile_Player_Fault_Tap_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playback paused — tap to retry`)
};

const es_mobile_player_fault_tap_retry = /** @type {(inputs: Mobile_Player_Fault_Tap_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducción en pausa: toca para reintentar`)
};

/**
* | output |
* | --- |
* | "Playback paused — tap to retry" |
*
* @param {Mobile_Player_Fault_Tap_RetryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_fault_tap_retry = /** @type {((inputs?: Mobile_Player_Fault_Tap_RetryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Fault_Tap_RetryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_fault_tap_retry(inputs)
	return en_mobile_player_fault_tap_retry(inputs)
});